import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, getValue } from "firebase/remote-config";
import { initializeApp } from "firebase/app";
import { ProductCategory } from "__generated__/msgTypes";
import { Option } from 'components/inputs/option';
import { productLabel } from './constants';
import { hasValue } from "components/inputs/inputHelpers";


export const appSettings = {
  appName: 'Messaging'
};

type ProductConfigMap = Record<ProductCategory, ProductConfig>;

const productConfig = (): ProductConfigMap => {
  return {
    [ProductCategory.Sms]: { enabled: true, displayName: productLabel(ProductCategory.Sms) }
  };
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 60000;

remoteConfig.defaultConfig = {
  "enable_feedback_alert": false,
  "enable_iotec_wallet_payment_method": false,
  "enable_new_contacts_layout": false,
  "enable_new_contact_groups_layout": false,
  "max_credits_top_up": 20000000,
  "iotec_bank_name": "Stanbic",
  "iotec_ugx_bank_account_number": "9030020293909",
  "iotec_usd_bank_account_number": "9030020370032",
  'feedback_survey_code': 'customer_feedback_001',
  'feedback_survey_url': 'www.iotec.io',
  'feedback_survey_title': 'We value your feedback',
  'feedback_survey_message': 'Please take a moment to share your experience using our app. It won\'t take more than 5 minutes. Your insights will help us improve our services.',

};

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const remoteConfigData = {
  enableNewContactsLayout: () => {
    return getValue(remoteConfig, 'enable_new_contacts_layout').asBoolean();
  },
  enableNewContactGroupsLayout: () => {
    return getValue(remoteConfig, 'enable_new_contact_groups_layout').asBoolean();
  },
  enableFeedbackAlert: () => {
    return getValue(remoteConfig, 'enable_feedback_alert').asBoolean();
  },
  enableSimRecentActivityCard: () => {
    return getValue(remoteConfig, 'enable_sms_recipient_activity').asBoolean();
  },
  enableGatewayConfigurationCard: () => {
    return getValue(remoteConfig, 'enable_sms_gateway_config_card').asBoolean();
  },
  enableIotecWalletPaymentMethod: () => {
    return getValue(remoteConfig, 'enable_iotec_wallet_payment_method').asBoolean();
  },
  maxCreditsTopUp: () => {
    return getValue(remoteConfig, 'max_credits_top_up').asNumber();
  },
  feedbackSurveyCode: () => {
    return getValue(remoteConfig, 'feedback_survey_code').asString();
  },
  feedbackSurveyUrl: () => {
    return getValue(remoteConfig, 'feedback_survey_url').asString();
  },
  feedbackSurveyTitle: () => {
    return getValue(remoteConfig, 'feedback_survey_title').asString();
  },
  feedbackSurveyMessage: () => {
    return getValue(remoteConfig, 'feedback_survey_message').asString();
  },
};



interface ProductConfig {
  enabled: boolean;
  displayName: string;
}

export const enabledProductOptions = (): Option[] => {
  const config = productConfig();

  return (Object.entries(config) as [ProductCategory, ProductConfig][])
    .filter(([, value]) => value.enabled)
    .map(([key, value]) => ({
      id: key,
      name: value.displayName
    }));
};

export const productDisplayName = (productCategory?: ProductCategory) : string => {
  if (hasValue(productCategory)) {
    return productConfig()[productCategory]?.displayName || '';
  } else {
    return '';
  }
};


